<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useTeambuildingState } from '~/js/stores/teambuildings-tm'
import { getClasses } from '~/js/composables/classes'
import { getGlobalTranslation } from '~/js/composables/translations'

import TextProse from '~/vue/_teammasters/atoms/texts/TextProse.vue'

interface Props {
    label: string
    utilities?: string,
}

/** 
 * VARIABLES
 * **/
// props & emits
withDefaults(defineProps<Props>(),{
    utilities: '',
})
const emit = defineEmits(['input'])

const teambuildingStore = useTeambuildingState()
const { filters } = storeToRefs(teambuildingStore)

// variables
const classes = {
    wrapper: {
        _default: 'relative',
        color: 'bg-white',
        rounded: 'rounded-sm',
        focus: 'focus-within:ring-3 focus-within:ring-yellow',
        spacing: 'px-4 py-1 space-y-1',
    },
    input: {
        _default: 'relative z-10',
        color: 'text-neutral-700',
        display: 'flex justify-between items-center',
        font: 'font-primary text-base ',
        size: 'w-full',
        spacing: 'py-1',
    },
}

/** 
 * METHODS
 * **/
const onHandleInput = evt => {
    const target = evt.currentTarget as HTMLInputElement | null
    if (target) {
        emit('input', target.value);
    }
}

</script>

<template>
    <div 
        :class="[
            getClasses(classes, 'wrapper'),
            utilities,
        ]" 
    >
        <legend class="sr-only">{{label}}</legend>
        <label>
            <TextProse size="text-sm" utilities="flex items-center gap-1 pt-1">
                <span>{{ label }}</span>
            </TextProse>

            <input
                :class="getClasses(classes, 'input')"
                :placeholder="getGlobalTranslation('Type and search on name')"
                @input="onHandleInput"
                type="text"
                v-model="filters.searchQuery"
            />
        </label>
    </div>
</template>